import React from 'react';

import {
  IIsStepHiddenContext,
  IsStepHiddenContext,
} from './IsStepHiddenContext';
import { ChallengeDataContext } from '../ChallengeDataProvider/ChallengeDataContext';
import { ParticipantStepsContext } from '../ParticipantStepsDataProvider/ParticipantStepsContext';
import { ParticipantSectionsContext } from '../ParticipantSections/ParticipantSectionsContext';
import { ExperimentsContext } from '../Experiments/ExperimentsContext';
import { Challenges } from '../../editor/types/Experiments';
import { V1ParticipantStep } from '@wix/ambassador-challenge-service-web/types';
import utils from '../../components/ChallengesPage/Widget/views/utils';

export const IsStepHiddenProvider: React.FC<IIsStepHiddenContext> = (props) => {
  const { challengeData } = React.useContext(ChallengeDataContext);
  const { enabled } = React.useContext(ExperimentsContext);
  const { listParticipantSections = [] } = React.useContext(
    ParticipantSectionsContext,
  );
  const { participantSteps } = React.useContext(ParticipantStepsContext);

  const isSections = listParticipantSections.length;
  const flatStepsList = isSections
    ? listParticipantSections.map((section) => section.steps || []).flat()
    : participantSteps?.steps || [];

  return (
    <IsStepHiddenContext.Provider
      value={{
        isStepHidden: (step: V1ParticipantStep) => {
          return utils.isStepHidden(
            challengeData?.challenge,
            flatStepsList,
            step,
            enabled(Challenges.isHiddenStepsEnabled),
          );
        },
        isVisibleStepLockedForComplete: (step: V1ParticipantStep) => {
          return utils.isVisibleStepLockedForComplete(
            challengeData?.challenge,
            flatStepsList,
            step,
            enabled(Challenges.isHiddenStepsEnabled),
          );
        },
      }}
    >
      {props.children}
    </IsStepHiddenContext.Provider>
  );
};
